import { useMediaQuery, useTheme } from '@mui/material';
import { DateRange } from '@pinnacleautomotive/clarity-components';
import React, { useEffect } from 'react';

const CustomDateRange = ({
  dateRange,
  setDateRange,
  setQuickDate,
  setSelectedFilters,
  handleDateError,
}) => {
  const theme = useTheme();
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (
      dateRange.startingDate &&
      dateRange.endDate &&
      Object.keys(dateRange.formattedDate).length === 2
    )
      setSelectedFilters(state => ({
        ...state,
        selectedDate: dateRange.formattedDate,
      }));
  }, [
    dateRange.endDate,
    dateRange.formattedDate,
    dateRange.startingDate,
    setSelectedFilters,
  ]);

  const handleSetDateRange = fn => {
    setDateRange(fn(dateRange));
    setQuickDate(null);
  };

  return (
    <DateRange
      startingDate={dateRange.startingDate}
      endDate={dateRange.endDate}
      sx={{
        width: '100%',
        paddingBottom: '0px',
        gap: { xs: 1, sm: 2 },
        ...(smallScreen && { flexWrap: 'wrap' }),
      }}
      DateLimiterErrorHandler={error => handleDateError(error)}
      dateInUTC={true}
      rangeLimit={{ days: 60 }}
      setPeriod={handleSetDateRange}
    />
  );
};

export default CustomDateRange;
